module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":{"first":"First name","last":"Last name"},"dob":"Date of birth","country":"Nationality"},"sl":{"name":{"first":"Ime","last":"Priimek"},"dob":"Datum rojstva","country":"Državljanstvo"}}')
  delete Component.options._Ctor
}
